import { render, staticRenderFns } from "./advance-configuration-setting-global.vue?vue&type=template&id=5376141e&"
import script from "./advance-configuration-setting-global.vue?vue&type=script&lang=js&"
export * from "./advance-configuration-setting-global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports